import {convertUserAccessRightsDataFromRpc} from '../utils'

export const EXCEPTIONS = {
    EditUserConfirmationIsNeededException: "com.actimind.common.administration.EditUserConfirmationIsNeededException",
    DeleteUserConfirmationIsNeededException: "com.actimind.common.administration.DeleteUserConfirmationIsNeededException",
    UserIsLockedException: "com.actimind.actitime.administration.UserIsLockedException",
    UserEmailInvalidException: "com.actimind.common.services.UserEmailInvalidException",
    NoSuchUserException: "com.actimind.actitime.administration.NoSuchUserException",
    NoRightsToManageAccountSettings: "com.actimind.actitime.services.NoRightsToManageAccountSettings",
    DuplicateTimeZone: "com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException",
    DuplicateEffectiveDatesInUserSchedulesException: "com.actimind.actitime.services.DuplicateEffectiveDatesInUserSchedulesException",
    DuplicateEffectiveDatesInUserRatesException: "com.actimind.actitime.services.DuplicateEffectiveDatesInUserRatesException",
    AccountDisabledDueToThisProductLicenseException: "com.actimind.common.administration.AccountDisabledDueToThisProductLicenseException",
    AccountDisabledDueToOtherProductLicenseException: "com.actimind.common.administration.AccountDisabledDueToOtherProductLicenseException",
    AccountDisabledDueToBothProductsLicenseException: "com.actimind.common.administration.AccountDisabledDueToBothProductsLicenseException",
    LeavesOrTTBeforeNewHireDateException: "com.actimind.common.services.LeavesOrTTBeforeNewHireDateException",
    NoSuchUserGroupException: "com.actimind.actitime.administration.NoSuchUserGroupException",
    SelectedUserDeletedException: "com.actimind.actitime.administration.SelectedUserDeletedException",
    UserExistsException: "com.actimind.actitime.administration.UserExistsException",
}

export const pickLoggedInUserInfo = (fullUserInfo) => {
    return {
        ..._.pick(fullUserInfo, [
            'firstName',
            'lastName',
            'middleInitial',
            'username',
            'email',
            'userGroupId',
            'timeZoneGroupId',
            'pto',
            'sick',
            'accessRights',
        ]),
        accessRights: convertUserAccessRightsDataFromRpc(fullUserInfo),
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/util.js